<template>
  <v-menu :close-on-content-click="false" min-width="250">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <px-gestao-entrega-produto-saldo-edicao-dialog :saldo="saldo"
                                                     @change="emitChange">
        <template v-slot:activator="{ on }">
          <v-list-item v-on="on"
                       :disabled="isCancelado || loading">
            <v-list-item-content>
              <div>
                <v-icon>mdi-pencil</v-icon>
                Editar este saldo
              </div>
            </v-list-item-content>
          </v-list-item>
        </template>
      </px-gestao-entrega-produto-saldo-edicao-dialog>
      <v-list-item :disabled="!isPendente || loading"
                   @click="onClickCancelarSaldo">
        <v-list-item-content>
          <div>
            <v-icon>mdi-close</v-icon>
            Cancelar este saldo
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <px-confirm-dialog ref="confirm"/>
  </v-menu>
</template>

<script>
import { SituacaoGestaoEntregaProdutoSaldo } from 'px-business-components';
import GestaoEntregaProdutoSaldoEdicaoDialog
  from '@/modules/gestao-entregas/GestaoEntregaProdutoSaldoEdicaoDialog.vue';
import GestaoEntregaService from '@/modules/gestao-entregas/gestao-entrega-service';

export default {
  props: {
    saldo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    isCancelado() {
      return this.saldo.situacaoEntrega === SituacaoGestaoEntregaProdutoSaldo.keys.CANCELADO.key;
    },
    isPendente() {
      return this.saldo.situacaoEntrega === SituacaoGestaoEntregaProdutoSaldo.keys.PENDENTE.key;
    },
  },
  methods: {
    emitChange(data) {
      this.$emit('change', data);
    },
    cancelarSaldo() {
      this.loading = true;
      GestaoEntregaService.cancelarSaldo(this.saldo.id)
        .then(({ data }) => {
          this.emitChange(data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickCancelarSaldo() {
      this.$refs.confirm.open('Você deseja cancelar este saldo?',
        'A quantidade do item será alterado.',
        { width: 400 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.cancelarSaldo();
        });
    },
  },
  components: {
    pxGestaoEntregaProdutoSaldoEdicaoDialog: GestaoEntregaProdutoSaldoEdicaoDialog,
  },
};
</script>
